
// UserGroupsManagementDashboard.jsx
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Latex from "react-latex";
// import he from "he";
// import UserGroupsManagementTable from "./UserGroupsManagementTable";
// import EndPoints from "../../../Api/EndPoints";

// const UserDashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
//   setPagePath,
// }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const navigate = useNavigate();
//   const accessToken = localStorage.getItem("other");
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);

//   useEffect(() => {
//     if (dataClient) {
//       fetchDashboardData();
//     }
//   }, [dataClient]);

//   const renderQuestionText = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={index}
//             src={imageUrl}
//             alt={`Question Image ${index}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;

//   const fetchDashboardData = async () => {
//     try {
//       const response = await fetch(
//         `${EndPoints.GetUsersDashboardDetails}?client_id=${clientId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(
//           "Failed to fetch dashboard data. Please check the API or authentication details."
//         );
//       }

//       const result = await response.json();
//       const tableData = result?.data || [];
//       const rawHeaders = tableData[0] || [];
//       const rows = tableData.slice(1) || [];

//       const formattedHeaders = rawHeaders.map((header) =>
//         String(header).replace(/^[a-zA-Z]\*/, "")
//       );
//       const transformedRows = rows.map((row) =>
//         row.map((cell) => {
//           if (cell === "" || cell === null || cell === undefined) {
//             return "---";
//           }
//           return cell;
//         })
//       );

//       setHeaders(formattedHeaders);
//       setReportDashboardData(transformedRows);
//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//     }
//   };

//   const handleCancel = () => {
//     window.location.reload();
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "37px",
//         marginBottom: "40px",
//       }}
//     >
//       <div className="">
//         <div
//           style={{
//             backgroundColor: "white",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             zIndex: 1001,
//             top: 0,
//           }}
//         >
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>
//             User Dashboard
//           </p>
//           <div style={{ display: "flex" }}>
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//               }}
//               onClick={handleCancel}
//             >
//               CANCEL
//             </button>
//             <button
//               className="create-test-section-btn"
//               style={{
//                 marginRight: "18px",
//                 width: "200px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//                 backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
//                 cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
//                 color: selectedRows.length > 0 ? "#424342" : "",
//               }}
//               disabled={selectedRows.length === 0}
//               onMouseEnter={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "#fa4741";
//                   e.target.style.color = "white";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (selectedRows.length > 0) {
//                   e.target.style.backgroundColor = "white";
//                   e.target.style.color = "#424342";
//                 }
//               }}
//               onClick={() => {
//                 if (selectedRows.length > 0) {
//                   const selectedUser = reportDashboardData.find(
//                     (row) => row[0] === selectedRows[0]
//                   );
//                   const staffNumber = selectedUser ? selectedUser[2] : "";
//                   const userIdForApi = selectedUser ? selectedUser[7] : ""; // user_id from table (index 7)
//                   const comments = selectedUser ? selectedUser[8] : ""; // comments from table (index 8)

//                   const params = new URLSearchParams();
//                   params.set("MNTStaffNumbr", staffNumber);
//                   if (userIdForApi !== undefined && userIdForApi !== null) {
//                     params.set("user_id", String(userIdForApi));
//                   }
//                   if (comments !== undefined && comments !== null) {
//                     params.set("comments", String(comments));
//                   }

//                   navigate(`/manage_group_access?${params.toString()}`);
//                 }
//               }}
//             >
//               MANAGE GROUP ACCESS
//             </button>

//             <button
//               className="create-test-section-btn"
//               onClick={() => {
//                 navigate(`/updated_user_group`);
//               }}
//             >
//               NEW
//             </button>
//           </div>
//         </div>

//         <p style={{ marginTop: "10px", color: "#2F2E40" }}>
//           Created role requests are listed here click on a group name to check
//           status, edit or cancel the request or create a new request using New
//           button.
//         </p>

//         <div>
//           <UserGroupsManagementTable
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Question Papers..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//             renderQuestionText={renderQuestionText}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             bulk={false}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserDashboard;













// UserGroupsManagementDashboard.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Latex from "react-latex";
import he from "he";
import UserGroupsManagementTable from "./UserGroupsManagementTable";
import EndPoints from "../../../Api/Endpoints";

const UserDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
  }, [dataClient]);

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;

  const fetchDashboardData = async () => {
    try {
      const response = await fetch(
        `${EndPoints.PRISM_GET_USERS_DASHBOARD_DETAILS}?client_id=${clientId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to fetch dashboard data. Please check the API or authentication details."
        );
      }

      const result = await response.json();
      const tableData = result?.data || [];
      const rawHeaders = tableData[0] || [];
      const rows = tableData.slice(1) || [];

      // NOTE: original regex was probably not doing what's intended. Keep header strings as-is (or transform properly if needed).
      const formattedHeaders = rawHeaders.map((header) => String(header));
      const transformedRows = rows.map((row) =>
        row.map((cell) => {
          if (cell === "" || cell === null || cell === undefined) {
            return "---";
          }
          return cell;
        })
      );

      setHeaders(formattedHeaders);
      setReportDashboardData(transformedRows);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const handleCancel = () => {
    window.location.reload();
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "37px",
        marginBottom: "40px",
      }}
    >
      <div className="">
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 1001,
            top: 0,
          }}
        >
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            User Dashboard
          </p>
          <div style={{ display: "flex" }}>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
              onClick={handleCancel}
            >
              CANCEL
            </button>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                width: "200px",
                boxShadow: "0px 4px 4px 0px #00000040",
                backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
                cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
                color: selectedRows.length > 0 ? "#424342" : "",
              }}
              disabled={selectedRows.length === 0}
              onMouseEnter={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "#fa4741";
                  e.target.style.color = "white";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedRows.length > 0) {
                  e.target.style.backgroundColor = "white";
                  e.target.style.color = "#424342";
                }
              }}
              onClick={() => {
                if (selectedRows.length > 0) {
                  // selectedRows contains the IDs (row[0] for original implementation),
                  // but we will find the full row from reportDashboardData and pass emp_id additional param.
                  const selectedUser = reportDashboardData.find(
                    (row) => row[0] === selectedRows[0]
                  );

                  // Based on new API response shape you provided:
                  // 0: User Name
                  // 1: Employee Name
                  // 2: Staff Number
                  // 3: Manager Name
                  // 4: Designation
                  // 5: Faculty Flag
                  // 6: Status
                  // 7: User Id
                  // 8: Employee Id  <-- NEW
                  // 9: Comments     <-- moved to index 9

                  const staffNumber = selectedUser ? selectedUser[2] : "";
                  const userIdForApi = selectedUser ? selectedUser[7] : "";
                  const empIdForApi = selectedUser ? selectedUser[8] : ""; // NEW
                  const comments = selectedUser ? selectedUser[9] : ""; // updated index

                  const params = new URLSearchParams();
                  params.set("MNTStaffNumbr", staffNumber || "");
                  if (userIdForApi !== undefined && userIdForApi !== null) {
                    params.set("user_id", String(userIdForApi));
                  }
                  if (empIdForApi !== undefined && empIdForApi !== null) {
                    // pass emp_id explicitly
                    params.set("emp_id", String(empIdForApi));
                  }
                  if (comments !== undefined && comments !== null) {
                    params.set("comments", String(comments));
                  }

                  navigate(`/manage_group_access?${params.toString()}`);
                }
              }}
            >
              MANAGE GROUP ACCESS
            </button>

            <button
              className="create-test-section-btn"
              onClick={() => {
                navigate(`/updated_user_group`);
              }}
            >
              NEW
              <span style={{fontSize: "14px", fontWeight: "bold", padding: "0px 0px 1px 0px"}}>+</span>
            </button>
          </div>
        </div>

        <p style={{ marginTop: "10px", color: "#2F2E40" }}>
          Created users are listed here, click on a user name to check
          status, edit or cancel the request or create a new user using New
          button.
        </p>

        <div>
          <UserGroupsManagementTable
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Users..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            renderQuestionText={renderQuestionText}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            bulk={false}
          />
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;

